/* Kiddleton satın alma kutusu: karakter, beden, 1-4 adet (her adede ayrı seçim), panduf, sayaç, EasySell. */
(function () {
  if (window.kdlSatinAlHazir) return;
  window.kdlSatinAlHazir = true;

  function tl(kurus) {
    var t = Math.round(kurus) / 100;
    var tam = Math.floor(t);
    var s = String(tam).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var kr = Math.round((t - tam) * 100);
    return s + (kr ? ',' + String(kr).padStart(2, '0') : '') + ' TL';
  }
  function ilkKelime(s) { return String(s || '').trim().split(/\s+/)[0].toLocaleLowerCase('tr'); }

  function kur(kok) {
    var veri = JSON.parse(kok.querySelector('[data-kdl-veri]').textContent);
    var urun = veri.urun;
    var panduf = veri.panduf;
    var secenekler = veri.secenekler || [];
    var opsiyonlar = secenekler.map(function (o) { return o.name; });
    var cokOpsiyon = opsiyonlar.length > 1;
    var ilk = urun.variants.find(function (v) { return v.available; }) || urun.variants[0];
    var url = new URL(location.href);
    var urlVaryant = url.searchParams.get('variant');
    if (urlVaryant) ilk = urun.variants.find(function (v) { return String(v.id) === urlVaryant; }) || ilk;
    var karakterler = secenekler[0] ? secenekler[0].values : [];
    var bedenler = secenekler[1] ? secenekler[1].values : [];

    var durum = {
      adet: 1,
      panduf: false,
      birimler: [{ k: ilk.option1, b: ilk.option2 }]
    };
    for (var i = 1; i < 4; i++) {
      durum.birimler.push({ k: karakterler[i % karakterler.length] || ilk.option1, b: ilk.option2 });
    }

    function varyant(k, b) {
      return urun.variants.find(function (v) { return v.option1 === k && (!cokOpsiyon || v.option2 === b); });
    }
    function pandufVaryant(k) {
      if (!panduf) return null;
      var a = ilkKelime(k);
      return panduf.variants.find(function (v) { return ilkKelime(v.option1 || v.title) === a; }) || panduf.variants[0];
    }
    function pandufHediyeVaryant(k) {
      if (!veri.pandufHediye) return null;
      var a = ilkKelime(k);
      return veri.pandufHediye.find(function (v) { return ilkKelime(v.option1) === a && v.available; }) || null;
    }
    function teklifVar() { return !!veri.teklif && durum.adet >= 2; }
    function bedenNot(b) {
      var el = kok.querySelector('[data-beden="' + CSS.escape(b) + '"]');
      return el ? el.getAttribute('data-not') : '';
    }

    function kalemler() {
      var liste = [];
      for (var i = 0; i < durum.adet; i++) {
        var u = durum.birimler[i];
        var v = varyant(u.k, u.b);
        if (v) liste.push({ id: v.id, quantity: 1, fiyat: v.price });
        if (durum.panduf) {
          var p = teklifVar() ? pandufHediyeVaryant(u.k) : pandufVaryant(u.k);
          if (p) liste.push({ id: p.id, quantity: 1, fiyat: teklifVar() ? 0 : p.price });
        }
      }
      // Aynı varyantları birleştir
      var birlesik = [];
      liste.forEach(function (x) {
        var var_ = birlesik.find(function (y) { return y.id === x.id; });
        if (var_) var_.quantity += 1; else birlesik.push({ id: x.id, quantity: 1, fiyat: x.fiyat });
      });
      return birlesik;
    }
    function toplam() {
      var v1 = varyant(durum.birimler[0].k, durum.birimler[0].b) || ilk;
      var battaniye = durum.adet > 1 && veri.paket[String(durum.adet)] > 0 ? veri.paket[String(durum.adet)] * 100 : null;
      if (battaniye === null) {
        battaniye = 0;
        for (var i = 0; i < durum.adet; i++) { var v = varyant(durum.birimler[i].k, durum.birimler[i].b); battaniye += v ? v.price : v1.price; }
      }
      if (veri.teklif && durum.adet === 4 && veri.dortluYuzde > 0 && !(veri.paket['4'] > 0)) battaniye = Math.round(battaniye * (100 - veri.dortluYuzde) / 100);
      var p = 0;
      if (durum.panduf && !teklifVar()) for (var j = 0; j < durum.adet; j++) { var pv = pandufVaryant(durum.birimler[j].k); p += pv ? pv.price : 0; }
      return battaniye + p;
    }

    var cubuk = kok.querySelector('[data-yapiskan]');
    if (cubuk) document.body.appendChild(cubuk); // dönüşümlü üst öğeler position:fixed'i bozmasın
    function her(sec) { var a = [].slice.call(kok.querySelectorAll(sec)); if (cubuk) a = a.concat([].slice.call(cubuk.querySelectorAll(sec))); return a; }
    var galeriRay = kok.querySelector('[data-galeri-ray]');
    function galeriyeGit(medyaId, yumusak) {
      if (!medyaId || !galeriRay) return;
      var kare = galeriRay.querySelector('[data-medya-id="' + medyaId + '"]');
      if (!kare) return;
      if (window.matchMedia('(min-width: 990px)').matches) {
        var ilkKare = galeriRay.querySelector('.kdl-galeri__kare');
        if (ilkKare && ilkKare !== kare) galeriRay.insertBefore(kare, ilkKare);
      } else {
        galeriRay.scrollTo({ left: kare.offsetLeft - galeriRay.offsetLeft, behavior: yumusak ? 'smooth' : 'auto' });
      }
      kok.querySelectorAll('[data-kucuk]').forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-kucuk') === String(medyaId) ? 'true' : 'false'); });
    }

    function ciz() {
      var u0 = durum.birimler[0];
      var v0 = varyant(u0.k, u0.b) || ilk;
      kok.querySelectorAll('.kdl-karakterler [data-karakter]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-karakter') === u0.k ? 'true' : 'false'); });
      kok.querySelectorAll('.kdl-bedenler [data-beden]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-beden') === u0.b ? 'true' : 'false'); });
      kok.querySelectorAll('[data-adet]').forEach(function (b) { b.setAttribute('aria-pressed', Number(b.getAttribute('data-adet')) === durum.adet ? 'true' : 'false'); });
      var ad = kok.querySelector('[data-karakter-ad]'); if (ad) ad.textContent = u0.k;
      var bk = kok.querySelector('[data-baslik-karakter]'); if (bk && u0.k) bk.textContent = ' · ' + u0.k;
      var f = kok.querySelector('[data-fiyat]'); if (f) f.textContent = tl(v0.price);
      // Adet kartlarında tam fiyat (paket fiyatı girilmemişse)
      for (var n = 2; n <= 4; n++) {
        if (!(veri.paket[String(n)] > 0)) {
          var af = kok.querySelector('[data-adet-fiyat="' + n + '"]');
          var ae = kok.querySelector('[data-adet-eski="' + n + '"]');
          var indirimli = veri.teklif && n === 4 && veri.dortluYuzde > 0;
          if (af) af.textContent = tl(indirimli ? Math.round(v0.price * n * (100 - veri.dortluYuzde) / 100) : v0.price * n);
          if (ae) { ae.hidden = !indirimli; ae.textContent = indirimli ? tl(v0.price * n) : ''; }
        }
      }
      // Birimler
      var kutu = kok.querySelector('[data-birimler]');
      kutu.hidden = durum.adet < 2;
      if (durum.adet > 1) {
        var ozet = kok.querySelector('[data-birim-ozet]');
        var g0 = veri.karakterGorsel[u0.k];
        ozet.innerHTML = (g0 ? '<img src="' + g0 + '" alt="">' : '') + '<span><b>1. ' + esc(veri.birim) + ':</b> ' + esc(u0.k) + (u0.b ? ' · ' + esc(u0.b) : '') + ' <span class="kdl-alt">(' + esc(veri.seciliIlk) + ')</span></span>';
        var liste = kok.querySelector('[data-birim-liste]');
        var html = '';
        for (var i = 1; i < durum.adet; i++) {
          var u = durum.birimler[i];
          html += '<div class="kdl-kart kdl-birim" data-birim="' + i + '"><div class="kdl-birim__bas"><b>' + (i + 1) + '. ' + esc(veri.birim) + '</b><span class="kdl-alt">' + esc(u.k) + (u.b ? ' · ' + esc(u.b) : '') + '</span></div>';
          html += '<div class="kdl-birim__karakterler" role="group" aria-label="' + (i + 1) + '. ' + esc(veri.birim) + ' karakteri">';
          karakterler.forEach(function (k) {
            var g = veri.karakterGorsel[k];
            html += '<button type="button" class="kdl-karakter" data-birim-karakter="' + esc(k) + '" aria-label="' + esc(k) + '" aria-pressed="' + (k === u.k) + '">' + (g ? '<img src="' + g + '" alt="">' : '<span class="kdl-karakter__bos"></span>') + '</button>';
          });
          html += '</div>';
          if (bedenler.length) {
            html += '<div class="kdl-bedenler" role="group" aria-label="' + (i + 1) + '. ' + esc(veri.birim) + ' bedeni">';
            bedenler.forEach(function (b) { html += '<button type="button" class="kdl-beden kdl-beden--kucuk" data-birim-beden="' + esc(b) + '" aria-pressed="' + (b === u.b) + '">' + esc(b) + '</button>'; });
            html += '</div>';
          }
          html += '</div>';
        }
        liste.innerHTML = html;
      }
      // Panduf
      var pf = kok.querySelector('[data-panduf-fiyat]');
      if (pf && panduf) {
        var pt = 0, pc = 0; for (var j = 0; j < durum.adet; j++) { var pv = pandufVaryant(durum.birimler[j].k); pt += pv ? pv.price : 0; pc += pv ? Math.max(pv.compare || 0, pv.price) : 0; }
        if (teklifVar()) pf.innerHTML = '<s>+' + tl(pt) + '</s> Hediye'; else pf.innerHTML = (pc > pt ? '<s>' + tl(pc) + '</s> ' : '') + '+' + tl(pt);
        var pa = kok.querySelector('[data-panduf-alt]'); if (pa) pa.textContent = teklifVar() ? veri.pandufAltHediye : (durum.adet > 1 ? veri.pandufAltCok : veri.pandufAlt);
        var pb = kok.querySelector('[data-panduf-baslik]'); if (pb) pb.textContent = teklifVar() ? veri.pandufBaslikHediye : veri.pandufBaslik;
        var pgo = kok.querySelector('[data-panduf-gorsel]'); var pgs = veri.pandufGorsel[ilkKelime(u0.k)]; if (pgo && pgs && pgo.getAttribute('src') !== pgs) pgo.src = pgs;
        var pkk = kok.querySelector('[data-panduf]'); if (pkk) pkk.checked = durum.panduf;
      }
      var t = tl(toplam());
      her('[data-toplam], [data-toplam-cubuk]').forEach(function (el) { el.textContent = t; });
      var ts = kok.querySelector('[data-toplam-satir]'); if (ts) ts.hidden = !(durum.adet > 1 || durum.panduf);
      // Yapışkan çubuk
      if (!cubuk) return;
      var ya = cubuk.querySelector('[data-yapiskan-ad]'); if (ya) ya.textContent = u0.k;
      var yal = cubuk.querySelector('[data-yapiskan-alt]'); if (yal) yal.textContent = (durum.adet > 1 ? durum.adet + ' ' + veri.birim + ' · ' : '') + (u0.b || '') + (u0.b && bedenNot(u0.b) ? ' · ' + bedenNot(u0.b) : '');
      var yg = cubuk.querySelector('[data-yapiskan-gorsel]'); var gg = veri.karakterGorsel[u0.k];
      if (yg && gg) { yg.src = gg; yg.hidden = false; }
    }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    kok.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-olcu-ac]'))) {
        var pen = kok.querySelector('[data-olcu-pencere]');
        if (pen && pen.showModal) { pen.showModal(); }
        return;
      }
      if ((b = e.target.closest('[data-olcu-kapat]'))) { var pk2 = b.closest('dialog'); if (pk2) pk2.close(); return; }
      if (e.target.matches && e.target.matches('[data-olcu-pencere]')) { e.target.close(); return; }
      if ((b = e.target.closest('.kdl-karakterler [data-karakter]'))) {
        durum.birimler[0].k = b.getAttribute('data-karakter');
        var v = varyant(durum.birimler[0].k, durum.birimler[0].b);
        if (v && v.featured_media) galeriyeGit(v.featured_media.id, true);
        varyantUrl(v); ciz(); return;
      }
      if ((b = e.target.closest('[data-beden]'))) {
        durum.birimler[0].b = b.getAttribute('data-beden');
        varyantUrl(varyant(durum.birimler[0].k, durum.birimler[0].b)); ciz(); return;
      }
      if ((b = e.target.closest('[data-adet]'))) {
        var eski = durum.adet; durum.adet = Number(b.getAttribute('data-adet'));
        // Kardeş paketi: 2+'ya geçince hediye panduf kendiliğinden işaretlenir, 1'e dönünce geri alınır
        if (veri.teklif && eski < 2 && durum.adet >= 2 && !durum.panduf) { durum.panduf = true; durum.pandufOto = true; }
        if (veri.teklif && durum.adet < 2 && durum.pandufOto) { durum.panduf = false; durum.pandufOto = false; }
        ciz(); return;
      }
      if ((b = e.target.closest('[data-birim-karakter]'))) { durum.birimler[Number(b.closest('[data-birim]').getAttribute('data-birim'))].k = b.getAttribute('data-birim-karakter'); ciz(); return; }
      if ((b = e.target.closest('[data-birim-beden]'))) { durum.birimler[Number(b.closest('[data-birim]').getAttribute('data-birim'))].b = b.getAttribute('data-birim-beden'); ciz(); return; }
      if ((b = e.target.closest('[data-kucuk]'))) { galeriyeGit(b.getAttribute('data-kucuk'), true); return; }
      if ((b = e.target.closest('[data-siparis]'))) { siparis(b); return; }
      if ((b = e.target.closest('[data-sepete]'))) { sepeteEkle(b); return; }
    });
    if (cubuk) cubuk.addEventListener('click', function (e) { var b = e.target.closest('[data-siparis]'); if (b) siparis(b); });
    var pk = kok.querySelector('[data-panduf]');
    if (pk) pk.addEventListener('change', function () { durum.panduf = pk.checked; durum.pandufOto = false; ciz(); });

    function varyantUrl(v) {
      if (!v) return;
      var u = new URL(location.href); u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u.toString());
    }

    // Galeri kaydırınca küçük resim işareti
    if (galeriRay && 'IntersectionObserver' in window) {
      var go = new IntersectionObserver(function (gs) {
        gs.forEach(function (g) {
          if (g.isIntersecting && g.intersectionRatio > 0.6 && !window.matchMedia('(min-width: 990px)').matches) {
            var id = g.target.getAttribute('data-medya-id');
            kok.querySelectorAll('[data-kucuk]').forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-kucuk') === id ? 'true' : 'false'); });
          }
        });
      }, { root: galeriRay, threshold: [0.6] });
      galeriRay.querySelectorAll('.kdl-galeri__kare').forEach(function (k) { go.observe(k); });
    }

    function hata(m) { var h = kok.querySelector('[data-hata]'); h.textContent = m || ''; h.hidden = !m; }

    function siparis(buton) {
      hata('');
      var liste = kalemler().map(function (x) { return { id: x.id, quantity: x.quantity }; });
      if (!liste.length) { hata('Lütfen karakter ve beden seç.'); return; }
      window.pmpr_cart_item = liste;
      var es = kok.querySelector('[data-easysell] .es-popup-button') || document.querySelector('.es-popup-button');
      if (es) {
        es.click();
        return;
      }
      // EasySell yoksa: sepete ekle, ödemeye geç
      buton.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: liste })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
      }).catch(function () { buton.disabled = false; hata('Bir sorun oldu, lütfen tekrar dene ya da bize WhatsApp\'tan yaz.'); });
    }

    // Sepete ekle: seçilen kalemler sepete, Horizon çekmecesi açılır (ödeme sayfasında kart ve kapıda ödeme var)
    function sepeteEkle(buton) {
      hata('');
      var liste = kalemler().map(function (x) { return { id: x.id, quantity: x.quantity }; });
      if (!liste.length) { hata('Lütfen karakter ve beden seç.'); return; }
      buton.disabled = true;
      var kok_ = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var bitti = function () { buton.disabled = false; };
      if (window.kdlSepeteEkle) {
        // Horizon olayı: çekmece kendi açılır (assets/kdl-sepet.js)
        window.kdlSepeteEkle(buton, liste).then(bitti).catch(function () { bitti(); hata('Sepete eklenemedi, lütfen tekrar dene.'); });
        return;
      }
      fetch(kok_ + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: liste })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        location.href = kok_ + 'cart';
      }).catch(function () { bitti(); hata('Sepete eklenemedi, lütfen tekrar dene.'); });
    }

    // Teslimat: kargo günü + tahmini teslim tarihi (İstanbul saatiyle)
    var teslim = kok.querySelector('[data-teslim]');
    if (teslim) {
      var AY = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
      var GUN = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
      var kesim = Number(teslim.getAttribute('data-kesim')) || 17;
      var cumartesi = teslim.getAttribute('data-cumartesi') === 'true';
      var tMin = Number(teslim.getAttribute('data-min')) || 1, tMax = Number(teslim.getAttribute('data-max')) || 2;
      var tatil = (teslim.getAttribute('data-tatil') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      var hesapla = function () {
        var p = {}; new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
        var bugun = new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), saat = +p.hour % 24;
        var anahtar = function (d) { return d.toISOString().slice(0, 10); };
        var ekle = function (d, n) { var x = new Date(d); x.setUTCDate(x.getUTCDate() + n); return x; };
        var kargoGunu = function (d) { var g = d.getUTCDay(); return g !== 0 && (g !== 6 || cumartesi) && tatil.indexOf(anahtar(d)) < 0; };
        var isGunu = function (d) { var g = d.getUTCDay(); return g !== 0 && g !== 6 && tatil.indexOf(anahtar(d)) < 0; };
        var cikis = bugun;
        if (!(kargoGunu(bugun) && saat < kesim)) { cikis = ekle(bugun, 1); while (!kargoGunu(cikis)) cikis = ekle(cikis, 1); }
        var ileri = function (n) { var d = cikis, k = 0; while (k < n) { d = ekle(d, 1); if (isGunu(d)) k++; } return d; };
        var a = ileri(tMin), b = ileri(tMax);
        var fark = Math.round((cikis - bugun) / 86400000);
        var gunAd = fark === 0 ? 'Bugün' : fark === 1 ? 'Yarın' : GUN[cikis.getUTCDay()];
        var tarih = a.getUTCMonth() === b.getUTCMonth()
          ? (a.getUTCDate() === b.getUTCDate() ? a.getUTCDate() : a.getUTCDate() + '-' + b.getUTCDate()) + ' ' + AY[b.getUTCMonth()]
          : a.getUTCDate() + ' ' + AY[a.getUTCMonth()] + ' - ' + b.getUTCDate() + ' ' + AY[b.getUTCMonth()];
        teslim.querySelector('[data-kargo-gun]').textContent = gunAd + ' kargoda';
        if (fark !== 0) teslim.querySelector('[data-kargo-not]').textContent = 'Şimdi verilen siparişler';
        teslim.querySelector('[data-teslim-tarih]').textContent = tarih;
      };
      try { hesapla(); setInterval(hesapla, 60000); } catch (e) {}
    }

    // Sayaç (bitince baştan başlar; kullanıcı kararı 15 Eki: mevcut sayaç aynen)
    var sayac = kok.querySelector('[data-sayac]');
    if (sayac) {
      var dk = Number(sayac.getAttribute('data-dakika')) || 10;
      var anahtar = 'kdl-sayac-' + urun.id;
      var bitis = 0;
      try { bitis = Number(sessionStorage.getItem(anahtar)) || 0; } catch (e) {}
      var sureEl = sayac.querySelector('[data-sayac-sure]');
      var adim = function () {
        var simdi = Date.now();
        if (!bitis || bitis <= simdi) { bitis = simdi + dk * 60000; try { sessionStorage.setItem(anahtar, String(bitis)); } catch (e) {} }
        var kalan = Math.max(0, Math.floor((bitis - simdi) / 1000));
        sureEl.textContent = String(Math.floor(kalan / 60)).padStart(2, '0') + ':' + String(kalan % 60).padStart(2, '0');
      };
      adim(); setInterval(adim, 1000);
    }

    // Yapışkan çubuk: ana buton ekrandan çıkınca
    var ana = kok.querySelector('.kdl-kutu [data-siparis]');
    if (ana && cubuk && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (gs) {
        var g = gs[0];
        cubuk.setAttribute('data-gorunur', !g.isIntersecting && g.boundingClientRect.top < 0 ? 'true' : 'false');
      }, { threshold: 0 }).observe(ana);
    }

    ciz();
    var v0 = varyant(durum.birimler[0].k, durum.birimler[0].b);
    if (urlVaryant && v0 && v0.featured_media) galeriyeGit(v0.featured_media.id, false);
  }

  function basla() { document.querySelectorAll('[data-kdl-satin-al]').forEach(function (k) { if (!k.dataset.kuruldu) { k.dataset.kuruldu = '1'; kur(k); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla); else basla();
  document.addEventListener('shopify:section:load', basla);
})();
